import React from "react";
import { Barn } from "../../models";
import AddBarnPersonButton from "./AddBarnPersonButton";
import { useHistory } from "react-router";

interface _Props {
    barn?: Barn
}

const AddBarnPersonCard: React.FC<_Props> = ({barn}) => {
    const history = useHistory();

    const handleSubmit = () => {
        let path = "/index/staff/barn/create/person/";
        if (barn) {
            path = path + barn.id;
        }
        history.push(path);
    }

    return (
        <>
            <AddBarnPersonButton onSubmit={handleSubmit} />
        </>
    );
};

export default AddBarnPersonCard;
